import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { DocumentCategory } from '../pages/Documents/Documents';

const GET_DOCUMENTS = gql`
  query GetDocuments($userId: Float!, $categories: [String!]) {
    documents(userId: $userId, categories: $categories) {
      id
      fileName
      category
      uploadDate
      blobId
      documentType
    }
  }
`;

export interface Document {
  id: number;
  fileName: string;
  category: string; // Backend returns raw category strings like 'BANK_STATEMENTS'
  uploadDate: string; // ISO date string
  blobId: string;
  documentType: string;
}


interface DocumentsData {
  documents: Document[];
}

interface DocumentsVars {
  userId: number;
  categories?: string[];
}

export const useClientDocuments = (userId: number, categories?: string[]) => {
  const { data, loading, error, refetch } = useQuery<DocumentsData, DocumentsVars>(
    GET_DOCUMENTS,
    {
      variables: { userId, categories },
      errorPolicy: 'all',
      skip: !userId,
      onCompleted: (data) => {
        console.log('Documents request completed:', {
          userId,
          categories,
          response: data,
          documentsCount: data?.documents?.length || 0
        });
      },
      onError: (error) => {
        console.error('Documents request failed:', {
          userId,
          categories,
          error: error.message,
          graphQLErrors: error.graphQLErrors,
          networkError: error.networkError
        });
      }
    }
  );

  return {
    documents: data?.documents || [],
    loading,
    error,
    refetch
  };
};
